<template>
    <div class="row justify-content-center mt-3 mb-3 px-2">
        <div class="col col-sm-auto menu-container">
            <div class="text-center row justify-content-center align-items-center">
                <router-link to="/quote" class="menu border-left col col-sm-auto">
                    Stock Quote
                </router-link>
                <router-link to="/chart" class="menu border-color col col-sm-auto">
                    Full Chart
                </router-link>
                <router-link to="/screen" class="menu border-right col col-sm-auto">
                    Stock Screening
                </router-link>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Menu',
    }
</script>

<style lang="scss" scoped>
    @import "../assets/css/colors";

    .menu-container {
        background-color: #c8c8c8;
        border-radius: 4px;
    }

    .menu {
        cursor: pointer;
        padding: 4px;
        color: $black;
    }

    .active {
        // border-radius: 4px;
        background-color: $primary;
        color: $white;
    }
    .border-left{
        border-radius: 4px 0px 0px 4px;
    }
    .border-right{
        border-radius: 0px 4px 4px 0px;
    }

    a {
        text-decoration: none;
    }
    .border-color{
        border-right: 1.5px solid #a5a2a2;
        border-left: 1.5px solid #a5a2a2;
    }
</style>
